import { SafariObject, SafariObjectId } from '../../../base-object/models/app/safari-object-base';
/**
 * This is a common model for all download file links
 * All tempLink endpoints share this with the exception of varying
 * filters property. Our common model will define it as any and it will
 * be the responsibility of the consuming component to cast it to the
 * right filters.
 * THe "right" filters will be declared in the respective data-access layers.
 *
 * P.S. In the API filters are flattened in the same object. On our side we'll keep
 * them as as separate property and the adapter will flatten it before sending it to the API
 */

export class AttachmentLink extends SafariObject {
  name?: string | undefined;
  contentType?: string | undefined;
  sizeInBytes?: number;

  openInBrowser?: boolean;
  attachmentIds?: SafariObjectId[];
  filters?: any;
  durationInMinutes?: number;
  linkUrl?: string | undefined;
  dateLinkExpires?: string;
}
